import React, { Fragment, useEffect, useState } from 'react';
import Loader from '../../components/Loader/Loader';
import { Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import TextInput from '../../components/InputFields/TextInput';
import { useDispatch, useSelector } from 'react-redux';
import { getAllApplication } from '../../api/Applications';
import { decryptData } from '../../utils/helper';
import { failed, success } from '../../utils/Tostify';
import { trackeApplication } from '../../api/Activity';

const TrackedApplicationModal = ({setShowModal, refech,handleSignIn, trackedApplication}) => {
  let token = useSelector(state => state.userReducer.token);
  const [isLoading, setIsLoading] = useState(false);
  const [applicationList, setApplicationlist] = useState([]);
  const [selectedApplication, setSelectedApplication] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();

const handleSubmit = async(e)=>{
    e.preventDefault();
    if(!selectedApplication){
      setError("Required field.");
      return;
    }
    let res;
    try {
      const values = {
        applicationId : selectedApplication,
        action : "add"
      };
      setIsLoading(true);
      res = await trackeApplication({ values, dispatch, token });
      if (res?.status == "SUCCESS") {
        await refech();
        await handleSignIn();
        setShowModal();
        setIsLoading(false);
        success(res?.message);
      } else {
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      setIsLoading(false);
      failed(res?.message);
    }
    return;
};

  const getApplicationList = async () => {
    let res;
    try {
        setIsLoading(true);
        res = await getAllApplication({
            dispatch,
            token,
            clinicId: localStorage.getItem("currentHospitalId")
        });
        const responseData = decryptData(res?.data);
        if (res?.status === "SUCCESS") {
            const trackedApplicationIds = new Set(trackedApplication?.map(app => app?._id));
            const filteredApplications = responseData?.list?.items.filter(obj =>
                obj?.consultantId !== localStorage.getItem("userId") &&
                !obj?.archieve &&
                obj?.status !== "Approved" && obj?.status !== "NotApproved" &&
                !trackedApplicationIds.has(obj?._id)
            );
            setApplicationlist(
                filteredApplications.map(obj => ({
                    label: `${decryptData(obj?.patientData?.name[0].text)} - ${obj?.applicationID}- ${obj?.title || " "}`,
                    value: obj?._id
                }))
            );
        }
    } catch (error) {
        failed(res?.message || "Failed to fetch applications.");
    } finally {
        setIsLoading(false);
    }
};

  useEffect(() => {
    getApplicationList();
  }, []);
  return (
    <Fragment>
      <Modal isOpen={setShowModal} toggle={setShowModal} size="xl" className='user_modal_block'>
        <ModalHeader toggle={setShowModal} className="assign_blk">Select Application</ModalHeader>
        <Form onSubmit={handleSubmit}>
            <ModalBody className="assign_modal_body">
            {isLoading ? <Loader /> : null}
            <div className="organization_form_block organization_blk organization_modal">
                <Row className='m-0'>
                    <Col lg={12} className="location_block mb-3 px-4">
                        <TextInput
                            keyField={"email"}
                            label="Select Application"
                            type="select"
                            options={applicationList}
                            value={selectedApplication}
                            onChange={(e) => {setSelectedApplication(e.target.value); setError("");}}
                        />
                        <span style={{color : "red"}}>{error}</span>
                    </Col>
                </Row>
            </div>
            </ModalBody>
            <ModalFooter className="p-0 mt-3">
            <div className="d-flex justify-content-center gap-5 mb-4">
                <button className="save_btn" onClick={setShowModal}>Close</button>
                <button className="save_btn second" type="submit">Save</button>
            </div>
            </ModalFooter>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default TrackedApplicationModal;
